import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import type { FinopsAlert } from '../../../../shared/types/finops';
import { AlertRow } from './AlertRow';

export function AlertsTable({
  items, expandedIds, onToggle, focusId, focusRef,
}: {
  items: FinopsAlert[];
  expandedIds: ReadonlySet<string>;
  onToggle: (id: string) => void;
  focusId: string | null;
  focusRef: (el: HTMLTableRowElement | null) => void;
}) {
  const { t } = useTranslation();
  return (
    <Card className="p-0 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-muted-foreground border-b">
            <tr>
              <th className="w-8" />
              <th className="py-2 pr-3">{t('finops.alerts.columns.severity')}</th>
              <th className="pr-3">{t('finops.alerts.columns.service')}</th>
              <th className="pr-3">{t('finops.alerts.columns.alert')}</th>
              <th className="pr-3">{t('finops.alerts.columns.account')}</th>
              <th className="pr-3">{t('finops.alerts.columns.deadline')}</th>
              <th className="pr-3 text-right">{t('finops.alerts.columns.pending')}</th>
              <th className="pr-3">{t('finops.alerts.columns.status')}</th>
              <th className="pr-3">{t('finops.alerts.columns.updated')}</th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <AlertRow
                key={a.id}
                alert={a}
                expanded={expandedIds.has(a.id)}
                onToggle={() => onToggle(a.id)}
                focused={a.id === focusId}
                rowRef={a.id === focusId ? focusRef : undefined}
              />
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
